import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"
import { fileUrl } from "./api";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function setFavicon(url) {
  if (!url) return;
  let link = document.querySelector("link[data-store-favicon]");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    link.setAttribute("data-store-favicon", "1");
    document.head.appendChild(link);
  }
  link.href = fileUrl(url);
}
